<script>
import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
  name: 'globalDistributionChart',
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    options: Object,
    myPositionIndex: {
      type: Number,
      default: 0,
    },
    comparisonPositionIndex: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.renderChart(this.chartData, {
      ...this.options,
      animation: {
        duration: 1,
        onComplete: () => {
          // eslint-disable-next-line no-underscore-dangle
          const chart = this.$data._chart;
          chart.ctx.textAlign = 'center';
          chart.ctx.textBaseline = 'bottom';
          this.chartData.datasets.forEach((dataset, i) => {
            const meta = chart.getDatasetMeta(i);
            meta.data.forEach((bar, index) => {
              const data = dataset.data[index];
              // eslint-disable-next-line no-underscore-dangle
              chart.ctx.fillText(data, bar._model.x, bar._model.y - 5);
            });
          });
        },
      },
    });

    this.$on('chart:render', this.updateAveragePos);
    this.$on('chart:update', this.updateAveragePos);
    window.addEventListener('resize', this.updateAveragePos);
    this.updateAveragePos();
  },
  beforeDestroy() {
    this.$off('chart:render', this.updateAveragePos);
    this.$off('chart:update', this.updateAveragePos);
    window.removeEventListener('resize', this.updateAveragePos);
  },
  methods: {
    updateAveragePos() {
      /* eslint-disable */
      if (this.$data._chart && this.$data._chart.getVisibleDatasetCount() > 0) {
        this.$emit('myAveragePosX', this.$data._chart.getDatasetMeta(0).data[this.myPositionIndex]._model.x);
        this.$emit('comparisonAveragePosX', this.$data._chart.getDatasetMeta(0).data[this.comparisonPositionIndex]._model.x);
      }
      /* eslint-enable */
    },
  },
};
</script>
